
            const data = {"name":"arrow-down","data":{"width":"18","height":"18","viewBox":"0 0 18 18","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M5.6 6.4L9 9.8l3.4-3.4 1.1 1.1L9 12 4.5 7.5z\"/>","originalColors":[{"type":"fill","color":"currentColor"}],"stopColors":[]}}
        
                module.exports = data
                